module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('transition-group', {
    staticClass: "accordion transition-wrapper",
    attrs: {
      "name": "accordion-transition",
      "tag": "div"
    },
    on: {
      "after-leave": _vm.expandingEnded
    }
  }, _vm._l((_vm.visibleCollections), function(collection) {
    return _c('collection', {
      key: collection.id,
      attrs: {
        "collection": collection,
        "isExpanded": collection.id === _vm.expandedCollection,
        "isLoading": _vm.isLoading,
        "isExpanding": _vm.isExpanding,
        "isActive": _vm.isActive(collection)
      },
      on: {
        "expand": _vm.expand,
        "collapse": _vm.collapse
      }
    }, [_vm._t("default", null, null, collection)], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fe9db98","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/admin/components/sidebar/Accordion.vue
// module id = zDmV
// module chunks = 0 1